<template>
  <div style="font-size:14px;margin-right:0px;margin-top:8px;float:right;">
    <div style="color: #ccc;text-align: center;margin-right: 10px">

      <!--<a v-if="userComTypeList.length > 1" style="margin-left: 5px;color: white; display: flex: align-items: center;">-->
        <!--<i class="el-icon-office-building"></i>-->
        <!--<span style="margin-left: 5px">-->
         <!--<el-dropdown  @command="handleCommand">-->
          <!--<span class="el-dropdown-link">-->
            <!--切换用户<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
          <!--</span>-->
          <!--<el-dropdown-menu slot="dropdown">-->
            <!--<el-dropdown-item v-for="(item,index) in userComTypeList" :key="index" :command="item">{{item.comtypename}}</el-dropdown-item>-->
          <!--</el-dropdown-menu>-->
        <!--</el-dropdown>-->
      <!--</span></a>-->
      <a :href="goHomeAddr" style="margin-right: 20px;font-wight:bold;color: #333; display: flex: align-items: center;"><i class="el-icon-office-building"></i><span style="margin-left: 5px">首页</span></a>
      <!-- <span @click="changePwd" style="margin-right: 20px;font-wight:bold;color: #333;cursor:pointer;display: flex: align-items: center;"><i class="el-icon-office-building"></i><span style="margin-left:5px">修改密码</span></span> -->
      <span @click="loginout" style="margin-right: 20px;font-wight:bold;color: #333;cursor:pointer;display: flex: align-items: center;"><i class="el-icon-user" ></i><span style="margin-left: 5px">退出登录</span></span>
    </div>
    <el-dialog  :close-on-click-modal="false" title="修改用户登录密码"
               :visible.sync="changePwdVisible">
      <el-form ref="selectrow" label-width="110px" class="fs2em">
        <el-form-item label="用户名">
          <span>{{username}}</span>
        </el-form-item>
        <el-form-item label="原密码" verify required >
          <el-input type="password"  v-model="userpwd"></el-input>
        </el-form-item>
        <el-form-item label="新密码" verify required >
          <el-input type="password"  v-model="userpwd1"></el-input>
          <div style="color: red">新密码要求是数字和字符的结合，不能少于8位数!</div>
        </el-form-item>
        <el-form-item label="确认密码" verify required >
          <el-input type="password"  v-model="userpwd2"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="onSubmit">确定</el-button>
        <el-button @click="changePwdVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>

<!--  <el-dropdown class="user-right ss-mr-10">-->
<!--    <span class="btn-text">您好, {{comname}}-{{username}}</span>-->
<!--    <el-dropdown-menu slot="dropdown">-->
<!--      <el-dropdown-item @click.native="changePwd"><icon name="edit"/>修改密码</el-dropdown-item>-->
<!--      <el-dropdown-item @click.native="loginout"><icon name="power-off"/>退出登录</el-dropdown-item>-->
<!--    </el-dropdown-menu>-->
<!--  </el-dropdown>-->
</template>

<script>
  import request from '@/utils/request'
  import Md5 from '@/assets/js/md5'
  import config from '@/assets/config'
  export default {
    data () {
      return {
        changePwdVisible: false,
        userpwd: '',
        userpwd1: '',
        userpwd2: ''
      }
    },
    created () {
    },
    methods: {
      // async handleCommand(command) {
      //   let user = await request({
      //     method: 'post',
      //     url: '/xtgl/user/cutLogin',
      //     data: {usercode: this.$store.getters.loginUser.usercode,password: this.$store.getters.loginUser.userpassword, comtype: command.comtypecode}
      //   })
      //   axios({
      //     method:'post',
      //     url: `${config.baseUrl}token/tokenUser`,
      //     headers: {
      //       'Authorization': `Bearer ` + user.token
      //     }
      //   }).then(async res => {
      //     let {data} = res
      //     data.token = user.token
      //     data.cacheToken = data.cacheToken
      //     this.$store.commit('set_user_info', data)
      //     await request({
      //       method: 'post',
      //       url: '/token/setCache',
      //       data: {key: data.cacheToken, val: data}
      //     })
      //     location.reload()
      //   })
      // },
      loginout () {
        // this.$confirm('确定退出登录吗?', '退出登录', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   this.$store.commit('login_out')
        //   location.reload()
        // })
        this.$confirm('确定退出登录吗?', '退出登录', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // request({
          //   method: 'post',
          //   url: '/token/setCache',
          //   data: {key: this.$store.state.user.loginUser.cacheToken}
          // }).then (() => {
          //   let cacheToken = this.$store.state.user.loginUser.cacheToken
          //   this.$store.commit('login_out')
          //   location.href = `${config.webUrl}/#/login?t=${cacheToken}`
          // })
          let local = window.localStorage
          local.clear()
          this.$store.commit('login_out')
          location.href = `${config.webUrl}/#/expertLogin?t=ttHn2WsPOQ2QrMHrhlksf`
        })
      },
      changePwd () {
        this.changePwdVisible = true
      },
      async onSubmit () {
        var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z!@+-=#*$%_]{8,}$/
        if (!this.userpwd) {
          this.$message.warning('请录入原密码')
          return
        } else if (!this.userpwd1) {
          this.$message.warning('请录入新密码')
          return
        } else if (!reg.test(this.userpwd1)) {
          this.$message.warning('新密码要求是数字和字符的结合，不能少于8位数!')
          return
        } else if (this.userpwd2!==this.userpwd1) {
          this.$message.warning('新密码与确认密码必须一致')
          return
        }
        let data = await request ({
          url: '/xtgl/user/changePwd',
          method: 'post',
          data: {
            usercode: this.$store.getters.loginUser.usercode,
            username: this.$store.getters.loginUser.username,
            oldpassword: Md5.md5(this.userpwd),
            userpassword: Md5.md5(this.userpwd2),
            userid: this.$store.getters.loginUser.userid
          }
        })
        if (data.issuccess === 1) {
          this.$message.success(data.msg)
          setTimeout(() => {
            request({
              method: 'post',
              url: '/token/setCache',
              data: {key: this.$store.state.user.loginUser.cacheToken}
            }).then(() => {
              let cacheToken = this.$store.state.user.loginUser.cacheToken
              this.$store.commit('login_out')
              location.href = `${config.webUrl}/#/login?t=${cacheToken}`
            })
          }, 1200)
        } else {
          this.$message.warning(data.msg)
        }
      }
    },
    computed: {
      goHomeAddr () {
        return this.$store.getters.loginUser.cosreturnurl
      },
      username () {
        return (this.$store.getters.loginUser.username || '') + '-' +(this.$store.getters.loginUser.usercode || '')
      },
      user_id () {
        return this.$store.getters.loginUser.userid
      },
      comname () {
        return this.$store.getters.loginUser.comfullname
      }
    }
  }
</script>

<style lang="scss" scoped>
  .el-dropdown {
    color:#fff;
    cursor: pointer;
  }
</style>
